import { ApiError } from 'api/api-error';
import { Exclude, Expose, Type } from 'class-transformer';
import { CatalogueAnimal } from './catalogue-animal';

/**
 * Response when validating animals from an uploaded spreadsheet.
 */
@Exclude()
export class CatalogueAnimals {
  /**
   * The errors, returns errors for any line in the file.
   */
  @Expose()
  errors: ApiError[];

  /**
   * The animals that have been validated.
   */
  @Expose({ name: 'validatedAnimals' })
  @Type(() => CatalogueAnimal)
  animals: CatalogueAnimal[];
}
